import { ICoderSkills, Itechnology } from '../../types/shared.types';
import * as type from '../ActionTypes';

export interface ITechnologyState {
  technologies: Itechnology[];
  skills: ICoderSkills[];
  loadingTech: boolean;
  error: any;
  techError: any;
  name: string | null;
}
const initialState: ITechnologyState = {
  skills: [],
  technologies: [],
  loadingTech: false,
  error: null,
  techError: null,
  name: null
};

export default function technologyReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.SET_TECHNOLOGY_NAME:
      return {
        ...state,
        name: action.name
      };
    case type.GET_ALL_TECHNOLOGIES:
      return {
        ...state,
        loadingTech: true
      };
    case type.GET_ALL_TECHNOLOGIES_SUCCESS:
      return {
        ...state,
        technologies: action.payload || [],
        loadingTech: false
      };
    case type.GET_ALL_TECHNOLOGIES_FAILURE:
      return {
        ...state,
        loadingTech: false,
        error: action.payload
      };
    case type.CLEAR_TECHNOLOGY_NAME:
      return {
        ...state,
        name: null
      };
    default:
      return state;
  }
}
